import { useEffect, useMemo } from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { pxToRem } from '../../utils/pxToRem';
import { conventionContent } from './content';
import { useActiveSection } from './hooks/useActiveSection';
import { TopBar } from './components/TopBar';
import { Hero } from './sections/Hero';
import { TheQuestion } from './sections/TheQuestion';
import { WhyForum } from './sections/WhyForum';
import { Speakers } from './sections/Speakers';
import { NotAStage } from './sections/NotAStage';
import { WhyParticipate } from './sections/WhyParticipate';
import { Venue } from './sections/Venue';
import { ExpressionOfInterest } from './sections/ExpressionOfInterest';
import { AboutForum } from './sections/AboutForum';
import { Footer } from './sections/Footer';

const visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0,0,0,0)',
  whiteSpace: 'nowrap',
  border: 0,
} as const;

export default function ConventionPage() {
  useEffect(() => {
    const previous = document.title;
    document.title = conventionContent.meta.title;
    return () => {
      document.title = previous;
    };
  }, []);

  const sectionIds = useMemo(
    () =>
      Array.from(new Set(conventionContent.nav.items.map((item) => item.targetId))),
    [],
  );
  const activeTargetId = useActiveSection(sectionIds);

  return (
    <>
      <Link
        href="#main-content"
        sx={{
          position: 'absolute',
          left: pxToRem(-9999),
          top: pxToRem(8),
          color: 'common.white',
          backgroundColor: 'primary.main',
          padding: `${pxToRem(8)} ${pxToRem(16)}`,
          zIndex: 1000,
          '&:focus, &:focus-visible': {
            left: pxToRem(8),
          },
        }}
      >
        {conventionContent.meta.skipToContent}
      </Link>
      <TopBar activeTargetId={activeTargetId} />
      <Hero />
      <Box component="main" id="main-content">
        <Box component="h1" sx={visuallyHidden}>
          {conventionContent.meta.title}
        </Box>
        <TheQuestion />
        <WhyForum />
        <NotAStage />
        <WhyParticipate />
        <Speakers />
        <Venue />
        <ExpressionOfInterest />
        <AboutForum />
      </Box>
      <Footer />
    </>
  );
}
